import React from 'react';
import Slider from 'react-slick';
import Title from '../layouts/Title';
import ProjectsCard from './ProjectsCard';
import { projectsData } from '../../data/data';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './ProjectsCarousel.css';

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <button
      className={`${className} custom-arrow left-[-40px] hover:text-blue-500`}
      onClick={onClick}
      style={{ ...style, display: "block" }}
      aria-label="Previous Slide"
    >
      ❮
    </button>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <button
      className={`${className} custom-arrow right-[-40px] hover:text-blue-500`}
      onClick={onClick}
      style={{ ...style, display: "block" }}
      aria-label="Next Slide"
    >
      ❯
    </button>
  );
};

const Projects = () => {
  const settings = {
    autoplay: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '30px',
    arrows: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerPadding: '20px',
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: '10px',
          dots: false,
        },
      },
    ],
  };

  return (
    <section id="projects" className="w-full py-20 border-b-[1px] border-b-black">
      <div className="flex justify-center items-center text-center">
        <Title title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK" des="My Projects" />
      </div>
      <Slider {...settings} className="projects-slider">
        {projectsData.slice().reverse().map((project) => (
          <div key={project.id} className="px-3 pb-8">
            <ProjectsCard title={project.title} des={project.des} src={project.src} github={project.github} weblink={project.weblink} />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Projects;
